'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var TypeCheck;
(function (TypeCheck) {
    function date(value) {
        return value instanceof Date;
    }
    TypeCheck.date = date;
    function number(value) {
        return (typeof value) === 'number';
    }
    TypeCheck.number = number;
    function string(value) {
        return (typeof value) === 'string';
    }
    TypeCheck.string = string;
    function boolean(value) {
        return (typeof value) === 'boolean';
    }
    TypeCheck.boolean = boolean;
    function object(value) {
        return (typeof value) === 'object';
    }
    TypeCheck.object = object;
    function array(value) {
        return Array.isArray(value);
    }
    TypeCheck.array = array;
    function func(value) {
        return (typeof value) === 'function';
    }
    TypeCheck.func = func;
    function symbol(value) {
        return (typeof value) === 'symbol';
    }
    TypeCheck.symbol = symbol;
    function defined(value) {
        return (typeof value) !== 'undefined' && value !== null;
    }
    TypeCheck.defined = defined;
    function emptyObj(value) {
        return !Object.keys(value).length;
    }
    TypeCheck.emptyObj = emptyObj;
    function json(value) {
        var parsed = false;
        try {
            JSON.parse(value);
            parsed = true;
        }
        catch (ignoredErr) {
            console.error(ignoredErr);
        }
        return parsed;
    }
    TypeCheck.json = json;
})(TypeCheck = exports.TypeCheck || (exports.TypeCheck = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/typeCheck.ts
// module id = 7
// module chunks = 0 1 2